<template>
    <div>
        <div class="modal-finished" v-if="currentStep === 0">
            <h4>Seu acesso foi criado com sucesso. Você já pode acessar nosso sistema e realizar o seu cadastro!</h4>
            <div class="img-box">
                <img src="@/assets/images/vector-fluxo-healthid-lab-com.png" width="300" />
            </div>
            <div class="button-box">
              <button  class="button btn-purple" v-if="!loading" @click="login()">
                Entrar no sistema
              </button>
              <button  class="button btn-purple" v-if="loading">
                <loading />
              </button>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: "register-tips",
        data() {
            return {
                currentStep: 0,
                loading: false
            }
        },
        methods: {
            switchStep(step){
                this.currentStep = step;
            },
            login() {
              this.loading = true;
              this.$emit('login');

            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .modal-finished {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        max-width: 400px;
        opacity: 0.5;
        animation: opacityUp 0.3s forwards;
    }

    @keyframes opacityUp {
        to {
            opacity: initial;
        }
    }

    .modal-finished label {
        text-align: center;
    }

    .modal-finished .button-box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
    }

    .modal-finished .button-box .button {
        max-width: 165px;
        margin: 15px 0px 0px 0px;
    }

    .modal-finished .button-box .button:disabled {
        opacity: .5;
        cursor: initial;
    }

    .modal-finished .button-box .button:disabled:hover,
    .modal-finished .button-box .button:disabled:active {
        background: var(--primary-color);
    }
</style>



// WEBPACK FOOTER //
// src/components/RegisterModal/steps/RegisterTips.vue